const serviceAreas = {
  serviceAreas: {
    pageHeader: 'Obszary usług',
    description:
      'Gdy właściciel domu będzie szukać instalatorów Enphase na określonym obszarze, użyjemy informacji „%{regionOrCountyLabel}” wprowadzonej tutaj, aby sprawdzić, czy jesteś dostępny do świadczenia usług w tym obszarze, czy nie.',
    addNewArea: 'Dodaj nowy obszar',
    new: 'Nowe',
    areaName: 'Nazwa obszaru',
    servicesCovered: {
      countiesCovered: 'Objęte powiaty',
      regionsCovered: 'Objęte regiony',
      provincesCovered: 'Prowincje objęte',
      regionsWithCount: 'Objęty %{region} (pierwsze cyfry kodów pocztowych: %{typeCharacters})',
      districtsCovered: 'Objęte dzielnice',
      citiesCovered: 'Objęte gminy',
      citiesCoveredbr: 'Miasta gminy',
      departments: 'jednostki',
      regions: 'regiony',
      counties: 'powiaty',
      districts: 'dzielnice',
      cities: 'gminy',
      provinces: 'Prowincje',
      city: 'miasta'
    },
    selectAllCounty: 'Wybierz wszystkie %{regionOrCountyLabel} z określonego województwa',
    selectAllCountyWithRegion: 'Wybierz wszystkie %{regionOrCountyLabel} Z określonego regionu',
    selectAllDepartment: 'Wybierz wszystkie jednostki',
    addCountiesRegionsButton: 'Dodaj %{regionOrCountyLabel}',
    countyButtonDescription:
      'Na podstawie wybranego województwa zostaną dodane wszystkie powiązane %{regionOrCountyLabel}',
    countyButtonDescriptionWithRegion: 'Na podstawie wybranego region zostaną dodane wszystkie powiązane %{regionOrCountyLabel}',
    area1: 'OBSZAR 1',
    selectState: 'Wybierz województwo',
    selectRegion: 'Wybierz region',
    requestNotProcessed: 'Nie udało się przetworzyć prośby',
    footerTitle:
      'Orientacyjna cena powinna obejmować koszty instalacji, stelażu, modułu fotowoltaicznego, falownika itp. Koszty takie jak pokrycie dachu czy modernizacja panelu głównego mogą mieć charakter dodatkowy',
    footerBody:
      'Firma Enphase przekaże właścicielowi domu tę orientacyjną cenę. Firma Enphase przekaże właścicielowi domu zastrzeżenie, że cena ma charakter wstępny i może ulec zmianie.',
    noBlankRegions: 'Pole dotyczące objętych %{regionOrCountyLabel} nie może być puste',
    deleteConfirmation: 'Czy na pewno chcesz usunąć ten obszar usług?',
    ok: 'OK',
    infoText:
      '%{bTagOpen}Region%{bTagClose} definiuje się jako pierwsze %{count} cyfry kodu pocztowego w %{stateOrProvince}',
    infoTextFr: 'Jednostka jest zdefiniowana jako pierwsze 2 cyfry kodu pocztowego',
    state: 'Stan',
    province: 'gmina',
    noOptions: 'Brak opcji'
  }
};

export default serviceAreas;
